<template>
  <article
    v-if="product"
    class=" position-relative product-box"
    :style="lowOpacity ? 'opacity: 0.7' : ''"
  >
    <DiscountTag
      :discountType="product.discount_type"
      :discount="product.discount"
    />

    <!-- <a @click.prevent="cachProduct" :href="to.href" class="text-center"> -->
    <div
      class="recommended-products-img text-center"
      :style="
        !product
          ? 'background-image: radial-gradient(#f4f4f4,#f4f4f4,#f4f4f4)'
          : ''
      "
    >
      <figure class="image-box-product">
        <a @click.prevent="cachProduct" :href="to.href" class="text-center">
          <template v-if="product && mainImage">
            <img
              loading="lazy"
              class="mainImage w-100"
              :src="getImage(mainImage, 'lg')"
              :alt="product.title"
            />
            <img
              loading="lazy"
              class="hoverImage w-100"
              v-if="hoverImage"
              :src="getImage(hoverImage, 'lg')"
              :alt="product.title"
            />
          </template>
          <img
            loading="lazy"
            v-else-if="product && lightMainImage"
            class=""
            :src="
              `https://api-atlasmode.alochand.com/storage/${lightMainImage}`
            "
            :alt="product.title"
          />
          <img
            loading="lazy"
            v-else
            class="skeleton-image"
            :alt="product ? product.title : ''"
          />

          <div class=" my-3 text-center btn-add-product">
            <!-- <a
            @click.prevent="cachProduct"
            :href="to.href"
            v-if="product != null"
            type="button"
            class="bg-white text-dark  fontsize-mini py-2 px-3 weight-bold "
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7729 9.30504V6.27304C15.7729 4.18904 14.0839 2.50004 12.0009 2.50004C9.91691 2.49104 8.21991 4.17204 8.21091 6.25604V6.27304V9.30504"
                stroke="#000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.7422 21.0003H7.25778C4.90569 21.0003 3 19.0953 3 16.7453V11.2293C3 8.87933 4.90569 6.97433 7.25778 6.97433H16.7422C19.0943 6.97433 21 8.87933 21 11.2293V16.7453C21 19.0953 19.0943 21.0003 16.7422 21.0003Z"
                stroke="#000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            افزودن به سبد
          </a> -->
            <!-- <a
            @click.prevent="cachProduct"
            :href="to.href"
            v-if="product != null"
            type="button"
            class="bg-white text-dark  fontsize-mini py-2 px-3 weight-bold "
          >
            
            مشاهده بیشتر
          </a> -->
          </div>
        </a>
        <div
          class="product-hover-rigth d-flex align-items-center justify-content-center"
        >
          <!-- <div  class=" product-rate  d-flex align-items-center justify-content-center">
        <a @click.prevent="cachProduct" :href="to.href" class="text-center d-flex align-items-center justify-content-center">

        <b-form-rating :value="product.rate" disabled size="sm" />

        <span class="fontsize11 text-color-999 number-product-rate "
          >(<span>{{ product.rate }}</span
          >)</span
        >
      </a>
      </div> -->
          <div class="eye-product">
            <a
              @click.prevent="cachProduct"
              :href="to.href"
              class="text-center text-black"
            >
              <eye color="#fff" />
            </a>
          </div>
          <div class="ProductFavorite">
            <ProductFavorite color="#fff" :productId="product ? product.id : null" />
          </div>
        </div>
      </figure>

      <!-- <div v-if="product" class="show-by-hover recommended-title-hover">
          <div
            class="product-rate d-flex align-items-center justify-content-center"
          >
            <b-form-rating :value="product.rate" disabled size="sm" />

            <span class="fontsize11 text-color-999"
              >(<span>{{ product.rate }}</span
              >)</span
            >
          </div>
          <h6 class="text-color-444 weight-bold fontsize-medium py-2 mb-0">
            {{ product.title }}
          </h6>
          <div v-if="product.status == 'available'">
            <span
              v-if="discountAmount && $route.path == '/'"
              class="text-color-themeRed fontsize-medium "
              >{{ mainPrice | price }}</span
            >

            <span v-else class="text-color-themeRed fontsize-medium ">{{
              mainPrice | price
            }}</span>
            <span class="text-color-666 fontsize14 pr-1">تومان</span>
            <span v-if="discountAmount != 0" class="pr-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                class="bi bi-chevron-double-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#aaa"
                  fill-rule="evenodd"
                  d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                />
                <path
                  fill="#aaa"
                  fill-rule="evenodd"
                  d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
              <span
                v-if="$route.path != '/'"
                class="line-through text-color-999 fontsize-small"
                >{{ (mainPrice + discountAmount) | price }}</span
              >
              <span
                v-else
                class="line-through  text-color-999 fontsize-small "
                >{{ mainPrice | price }}</span
              >
            </span>
          </div>
          <div v-else>
            <span
              v-if="product.status == 'out_of_stock'"
              class="text-color-themeRed fontsize14"
            >
              ناموجود
            </span>
            <span
              v-if="product.status == 'soon'"
              class="text-color-themeRed fontsize14"
            >
              به زودی
            </span>
          </div>
          <div class="recommended-products-cart my-3 text-center show-by-hover">
            <a
              @click.prevent="cachProduct"
              :href="to.href"
              v-if="product != null"
              type="button"
              class="bg-color-theme fontsize-mini py-2 px-3 weight-bold text-white"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7729 9.30504V6.27304C15.7729 4.18904 14.0839 2.50004 12.0009 2.50004C9.91691 2.49104 8.21991 4.17204 8.21091 6.25604V6.27304V9.30504"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.7422 21.0003H7.25778C4.90569 21.0003 3 19.0953 3 16.7453V11.2293C3 8.87933 4.90569 6.97433 7.25778 6.97433H16.7422C19.0943 6.97433 21 8.87933 21 11.2293V16.7453C21 19.0953 19.0943 21.0003 16.7422 21.0003Z"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              افزودن به سبد
            </a>
          </div>
        </div> -->
    </div>

    <a @click.prevent="cachProduct" :href="to.href" class="text-center">
      <div
        v-if="product"
        class="d-flex flex-column align-items-start position-relative"
      >
        <h6
          class="hide-by-hover text-pink-theme2 weight-bold fontsize-medium pt-0 mb-0 title-product"
        >
          {{ product.title.substr(0, 33) }}
          {{ product.title.length > 33 ? "..." : "" }}
        </h6>
        <!-- <div
          class=" product-rate  d-flex align-items-center justify-content-center"
        >
          <a
            @click.prevent="cachProduct"
            :href="to.href"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <b-form-rating :value="product.rate" disabled size="sm" />

            <span class="fontsize11 text-color-999 number-product-rate "
              >(<span>{{ product.rate }}</span
              >)</span
            >
          </a>
        </div> -->
        <div v-if="product.status == 'available'" class="hover-price">
          <div class="hover-price-content">
            <!-- <a
              @click.prevent="cachProduct"
              :href="to.href"
              v-if="product != null"
              type="button"
              class=" fontsize-mini  weight-bold add-card-product"
            >
              افزودن به سبد
            </a> -->
            
            <div class="hide-by-hover d-flex  flex-wrap">
              <div
              v-if="discountAmount != 0"
              class="pr-1 d-inline-block discountAmount-box "
            >
              
              <span
                v-if="discountAmount && $route.path != '/'"
                class="line-through text-color-999 fontsize-small"
                >{{ (mainPrice + discountAmount) | price }}</span
              >
              <span
                v-else
                class="line-through text-color-999 fontsize-small"
                >{{ (mainPrice + discountAmount) | price }}</span
              >
              <svg 
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                class="bi bi-chevron-double-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#aaa"
                  fill-rule="evenodd"
                  d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                />
                <path
                  fill="#aaa"
                  fill-rule="evenodd"
                  d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
              <span
                v-if="discountAmount && $route.path == '/'"
                class="text-dark font-weight-bold fontsize-medium"
              >
                {{ mainPrice | price }}
              </span>
              <span v-else class="text-dark font-weight-bold fontsize-medium">
                {{ mainPrice | price }}
              </span>
              <span class="text-color-666 fontsize-small pr-1">تومان</span>
             
              <!-- <div
              v-if="product.discount"
              :class="{ largeFont: product.discount.toString().length < 5 ,'transparent':product.discount_type == 'flat'}"
              class="discount__container__product d-inline-block mr-2"
              
              
            >
              <template v-if="product.discount_type != 'flat'">
                <span class="large">{{ product.discount | price }}</span>
                <span class="small">{{ product.discount_type == "flat" ? "تومان" : "%" }}</span>
              </template>
             
            </div> -->
            </div>
          </div>
        </div>
        <div v-else class="hide-by-hover ">
          <span
            v-if="product.status == 'out_of_stock'"
            class="text-pink-theme2 fontsize14"
          >
            ناموجود
          </span>
          <span
            v-if="product.status == 'soon'"
            class="text-pink-theme2 fontsize14"
          >
            به زودی
          </span>
        </div>
      </div>
      <div v-else class="mt-3">
        <b-skeleton />
        <b-skeleton class="mt-2" />
      </div>
    </a>
    <!-- <button
      class="videoPlayer"
      v-if="!Array.isArray(product.video)"
      @click="showVideo(product.video.url)"
    >
      <img src="@/assets/images/player.gif" alt="video player" />
    </button> -->

    <div id="showVideoBox" v-if="showVideoBox">
      <button id="closeVideoModal" @click="showVideoBox = false">
        <svg
          fill="#000000"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
          width="30px"
          height="30px"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          />
        </svg>
      </button>
      <video class="videoContent" width="100%" height="100%" controls>
        <source :src="playerOptions" type="video/mp4" />
      </video>
    </div>
    <img
      class="vipLable"
      v-if="$route.path != '/' && product.is_vip"
      src="@/assets/images/vip/vip.gif"
      alt="محصول وی آی پی"
    />
  </article>
</template>

<script>
import { BFormRating, BSkeleton } from "bootstrap-vue";
import ProductFavorite from "@/parts/Front/components/productDetail/ProductFavorite";
import eye from "../icons/eye.vue";

import { getImages, sortVarieties, getImage } from "@/libraries/functions";
import DiscountTag from "./DiscountTag";
export default {
  name: "Product",
  components: { DiscountTag, BFormRating, BSkeleton, ProductFavorite, eye },
  props: ["product", "lowOpacity"],
  data() {
    return {
      showVideoBox: false,
      playerOptions: null,
      image: null,
    };
  },
  methods: {
    getImage,
    cachProduct() {
      let product = this.product;
      product.isPreview = true;
      this.$store.commit("front/setProductLinkedInfo", product);
      this.$router.push(this.to.href);
    },
    showVideo(video) {
      this.playerOptions = video;
      this.showVideoBox = true;
    },
  },
  computed: {
    to() {
      return this.$router.resolve({
        name: "product.detail",
        params: { id: this.product.id, slug: this.product.slug },
      });
    },
    mainPrice() {
      return this.product ? this.product.major_final_price.amount : null;
    },
    discountAmount() {
      return this.product
        ? this.product.major_final_price.discount_price
        : null;
    },
    mainImage() {
      return this.product ? this.product.major_image : null;
    },
    lightMainImage() {
      return this.product && this.product.image && this.product.image.length
        ? this.product.image[0]
        : null;
    },
    hoverImage() {
      return this.product && this.product.images && this.product.images.length
        ? this.product.images[1]
        : null;
    },
  },
};
</script>

<style scoped>
.hover-price {
 /* overflow: hidden;
 height: 35px;
 */
  margin-top: 2px;
  text-align: right;
}

.add-card-product {
  transition: all 0.3s;
  margin-top: 3px;
}

.add-card-product:hover {
  background-color: var(--orang-theme);
  border: 1px solid var(--orang-theme); 
  color: #fff;
}

.hover-price-content {
 /* transform: translateY(-35px);
  transition: all 0.3s;*/

  
}

/*.hover-price-content a {
  color: #000;
  padding: 4px 11px;
  border: 1px solid #d7d7d7;
  border-radius: 8px;
}*/

.product-box:hover .hover-price-content {
 /* transform: translateY(0px);*/
}



.hoverImage {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  transition: all 0.5s;
}

.image-box-product {
  position: relative;
  overflow: hidden;
}

.product-box:hover .hoverImage {
  opacity: 1;
}

.btn-add-product {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 1rem;
  position: absolute;
  bottom: -70px;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.3s;
  margin-bottom: 0px !important;
  overflow: hidden;
  border-radius: 8px;
}

.btn-add-product a {
  overflow: hidden;
  border-radius: 8px;
}

.number-product-rate,
.number-product-rate span {
  color: #000 !important;
}

.product-hover-rigth {
  position: absolute;
  top: 16px;
  right: -35px;
  transition: all 0.3s;
  gap: 4px;
  flex-direction: column;
}

.eye-product,
.ProductFavorite {
  background-color: var(--orang-theme);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.discount__container__product {
  background-color: rgb(210 239 154);
  color: #000;
  padding: 0.125rem 0.75rem;
  border-radius: 9999px;
}

@media screen and (min-width: 960px) {
  .product-box:hover .product-hover-rigth {
    right: 10px;
  }

  .product-box:hover .btn-add-product {
    bottom: 10px;
  }
}
.hide-by-hover{
  margin-top: 3px;
}
@media screen and (max-width: 768px) {
  .recommended-content-item article:hover .hide-by-hover {
    opacity: 1 !important;
  }

  .discount__container__product {
    padding: 0.125rem 0.5rem;
    font-size: 14px;
  }
}

.skeleton-image {
  width: 100%;
  display: inline-block;
}
</style>
<style>
.product-rate .b-rating.disabled,
.b-rating:disabled {
  background-color: unset !important;
}

.ProductFavorite svg {
  width: 19px;
  height: 21px;
  transform: translateY(1px);
}

.eye-product *,
.ProductFavorite * {
  display: flex;
}

.eye-product svg {
  transform: translateY(1px);
}

.product-rate .form-control {
  padding: 0;
  border: unset !important;
  width: 100px;
  direction: ltr;
  margin-top: 0px;
}

.product-rate .b-rating .b-rating-star {
  padding: 0;
}

.product-hover-rigth .product-rate .b-rating .b-rating-star svg {
  width: 12px;
  height: 12px;
}

.product-hover-rigth .ProductFavorite svg path {
  stroke: #fff;
}

img.vipLable {
  position: absolute;
  z-index: 10000;
  width: 100px;
  left: 50%;
  transform: translateX(-50%);
  top: -50px;
}
</style>
